import React from 'react';
import alertImage from '../../assets/alert.png';
import './MessageModal.css';

const MessageModal = ({
  body,
  buttonText,
  hideClosebutton = false,
  image = alertImage,
  onButtonClick,
  title,
  visible,
}) => {
  const handleModalOverlayClick = (event) => {
    if (event.target.id === 'messageModalOverlay' && onButtonClick) {
      onButtonClick();
    }
  };

  const handleOnButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className="Message-modal-overlay"
      id="messageModalOverlay"
      onClick={handleModalOverlayClick}
      onKeyDown={handleModalOverlayClick}
      role="button"
      tabIndex={0}
    >
      <div className="Message-modal-card">
        <div className="Message-modal-card-content">
          <img
            alt=""
            className="Message-modal-image"
            src={image}
          />

          <span className="Message-modal-body-title">{title}</span>

          <div className="Message-modal-body-container">
            <p className="Message-modal-body-text">{body}</p>
          </div>

          {hideClosebutton
            ? null
            : (
              <button
                className="Message-modal-button"
                id="messageModalButton"
                onClick={handleOnButtonClick}
                type="button"
              >
                {buttonText}
              </button>
            )}
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
